import React, { useContext, useState } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { HeaderTitle, NotifyContext, Loading, Checkbox } from '../Library'
import { createPackage } from '../Network/Administration'
import { useHistory } from 'react-router-dom'

function CreatePackage() {
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration
    const notify = useContext(NotifyContext)
    const history = useHistory()

    const [packageName, setPackageName] = useState("")
    const [packageDetail, setPackageDetail] = useState("")
    const [isError, setError] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [limitUser, setLimitUser] = useState(1)
    const [isUnlimitedUser, setIsUnlimitedUser] = useState(false)
    const [limitTenants, setLimitTenants] = useState(1)
    const [isUnlimitedTenants, setIsUnlimitedTenants] = useState(false)

    const infoNotComplete = () =>{
        notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
        setError(true)
    }

    const submit = () =>{
        if(!packageName || !packageDetail){
            infoNotComplete()
            return
        }

        if(!isUnlimitedUser && !limitUser){
            infoNotComplete()
            return
        }

        if(!isUnlimitedTenants && !limitTenants){
            infoNotComplete()
            return
        }

        setLoading(true)
        var luser = limitUser
        var ltenant = limitTenants
        if(isUnlimitedUser){
            luser = 0
        }
        if(isUnlimitedTenants){
            ltenant = 0
        }

        createPackage(packageName, packageDetail, luser, ltenant,
            ()=>{
                notify.showNotify(lang.package_complete, lang.package_complete, 0)
                setLoading(false)
                history.push("/package")
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }

    return (
        <div id="create-package">
            { isLoading ? <Loading/> : null }
            <HeaderTitle title={lang.create_package} isShowBack backTo="/package"/>
            <Row>
                <Col md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault()
                        submit()
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{lang.package_name}</Form.Label>
                            <Form.Control
                            value={packageName}
                            onChange={(e)=>setPackageName(e.target.value)}
                            isInvalid={isError && !packageName}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.package_detail}</Form.Label>
                            <Form.Control 
                            as="textarea"
                            value={packageDetail}
                            onChange={(e)=>setPackageDetail(e.target.value)}
                            isInvalid={isError && !packageDetail}/>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{lang.maximum_user}</Form.Label>
                            <Form.Control
                            type="number"
                            min={1}
                            disabled={isUnlimitedUser}
                            value={limitUser}
                            isInvalid={isError && !limitUser && !isUnlimitedUser}
                            onChange={(e)=>setLimitUser(e.target.value)}
                            />
                            <Checkbox 
                            label={lang.unlimited_user}
                            checked={isUnlimitedUser}
                            onChange={()=>setIsUnlimitedUser(!isUnlimitedUser ? true : false)}
                            style={{ marginTop: 10 }}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.maximum_tenants}</Form.Label>
                            <Form.Control
                            type="number"
                            min={1}
                            disabled={isUnlimitedTenants}
                            value={limitTenants}
                            isInvalid={isError && !limitTenants && !isUnlimitedTenants}
                            onChange={(e)=>setLimitTenants(e.target.value)}
                            />
                            <Checkbox 
                            label={lang.unlimited_tenants} 
                            checked={isUnlimitedTenants}
                            onChange={()=>setIsUnlimitedTenants(!isUnlimitedTenants ? true : false)}
                            style={{ marginTop: 10 }}/>
                        </Form.Group>
                        <hr/>
                        <Button type="submit">
                            {lang.create_package}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default CreatePackage
